<div class="{{ translate.currentLang == 'ar' ? 'font-Arabic-regular' : '' }} ">
	<ng-container>
		<mat-sidenav-container [hasBackdrop]="!isOpen" class="bg-light-grey">
			<mat-sidenav
				#sidenav
				mode="side"
				class="width-400 text-tc bg-transparent {{ isOpen ? 'z-10' : '' }}"
				[opened]="isOpen"
			>
				<app-sidebar
					(closeMenu)="sidenav.close()"
					class="fixed top-0"
				></app-sidebar>
			</mat-sidenav>
			<mat-sidenav-content
				class="lg:ltr:ml-[213px] lg:rtl:mr-[213px] rtl:ml-0 ltr:mr-0 min-h-screen relative {{
					isOpen ? 'z-10' : ''
				}}"
			>
				<app-header
					class="w-full text-main-color-black"
					(toggleNav)="sidenav.toggle()"
				></app-header>
				<main
					class="bg-light-grey text-main-color-black lg:px-[36px] md:px-[26px] px-[14px] py-24px mt-[68px]"
				>
					<router-outlet></router-outlet>
				</main>
			</mat-sidenav-content>
		</mat-sidenav-container>
	</ng-container>
</div>
